var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a5.507 5.507 0 00-5.5 5.5c0 4.706 5 8.26 5.213 8.41a.502.502 0 00.574 0C8.5 14.76 13.5 11.205 13.5 6.5A5.506 5.506 0 008 1zm0 3.5a2 2 0 110 4 2 2 0 010-4z",
    fill: "#A7A7A7"
  })));
}
export default SvgMapPin;